import { useEffect, useState } from "react";
import { api, formatBRL } from "@/lib/api";
import { Package, ShoppingBag, DollarSign, AlertTriangle } from "lucide-react";

export default function Dashboard() {
  const [m, setM] = useState(null);
  const [orders, setOrders] = useState([]);
  useEffect(() => {
    api.get("/admin/metrics").then((r) => setM(r.data));
    api.get("/admin/orders").then((r) => setOrders((r.data || []).slice(0, 6)));
  }, []);

  const cards = [
    { icon: DollarSign, label: "Receita total", value: m ? formatBRL(m.revenue) : "—", testid: "metric-revenue" },
    { icon: ShoppingBag, label: "Pedidos", value: m?.orders_total ?? "—", sub: `${m?.orders_pending ?? 0} pendentes`, testid: "metric-orders" },
    { icon: Package, label: "Produtos", value: m?.products ?? "—", testid: "metric-products" },
    { icon: AlertTriangle, label: "Estoque baixo", value: m?.low_stock ?? "—", sub: "< 5 unidades", testid: "metric-stock" },
  ];

  return (
    <div>
      <div className="overline-label">Visão geral</div>
      <h1 className="font-display text-4xl text-white tracking-tighter mt-3">Dashboard</h1>

      <div className="grid grid-cols-1 md:grid-cols-4 gap-4 mt-8">
        {cards.map((c, i) => (
          <div key={i} className="border border-white/10 bg-[#0A0A0C] p-5" data-testid={c.testid}>
            <div className="flex items-center justify-between">
              <span className="overline-label">{c.label}</span>
              <c.icon size={16} className="text-zinc-500" />
            </div>
            <div className="font-display text-3xl text-white mt-3">{c.value}</div>
            {c.sub && <div className="text-xs text-zinc-500 mt-1">{c.sub}</div>}
          </div>
        ))}
      </div>

      <div className="mt-10">
        <h2 className="font-display text-xl text-white tracking-tight">Pedidos recentes</h2>
        <div className="border border-white/10 bg-[#0A0A0C] mt-4 overflow-x-auto">
          <table className="w-full text-sm">
            <thead className="text-xs tracking-widest uppercase text-zinc-500">
              <tr>
                <th className="text-left px-4 py-3">Código</th>
                <th className="text-left px-4 py-3">Cliente</th>
                <th className="text-left px-4 py-3">Pgto</th>
                <th className="text-left px-4 py-3">Status</th>
                <th className="text-right px-4 py-3">Total</th>
              </tr>
            </thead>
            <tbody>
              {orders.map((o) => (
                <tr key={o.id} className="border-t border-white/5">
                  <td className="px-4 py-3 font-mono text-xs">{o.code}</td>
                  <td className="px-4 py-3">{o.customer?.name}</td>
                  <td className="px-4 py-3">{o.payment_method === "pix" ? "Pix" : "Cartão"}</td>
                  <td className="px-4 py-3"><StatusPill s={o.status} /></td>
                  <td className="px-4 py-3 text-right font-display">{formatBRL(o.total)}</td>
                </tr>
              ))}
              {orders.length === 0 && (
                <tr><td colSpan="5" className="px-4 py-10 text-center text-zinc-500">Nenhum pedido ainda.</td></tr>
              )}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
}

export function StatusPill({ s }) {
  const map = {
    pending: ["Pendente", "bg-amber-500/15 text-amber-300 border-amber-500/30"],
    paid: ["Pago", "bg-emerald-500/15 text-emerald-300 border-emerald-500/30"],
    preparing: ["Preparando", "bg-sky-500/15 text-sky-300 border-sky-500/30"],
    shipped: ["Enviado", "bg-violet-500/15 text-violet-300 border-violet-500/30"],
    delivered: ["Entregue", "bg-emerald-500/15 text-emerald-300 border-emerald-500/30"],
    cancelled: ["Cancelado", "bg-red-500/15 text-red-300 border-red-500/30"],
  };
  const [label, cls] = map[s] || [s, "bg-white/5 text-zinc-300 border-white/10"];
  return <span className={`inline-block border px-2 py-0.5 text-[11px] tracking-wide uppercase ${cls}`}>{label}</span>;
}
